import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		padding: THEME.spacing.lg,
		width: '100%',
		boxSizing: 'border-box',
	},
	connectContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingTop: THEME.spacing.xl,
		paddingBottom: THEME.spacing.xl,
		paddingLeft: THEME.spacing.md,
		paddingRight: THEME.spacing.md,
		gap: THEME.spacing.lg,
	},
	title: {
		fontSize: THEME.typography.fontSizes.xl,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	headerContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: THEME.spacing.md,
	},
	reconnectNotice: {
		marginTop: SPACE[16],
		maxWidth: 640,
	},
	buttonGroup: {
		display: 'flex',
		gap: THEME.spacing.md,
		marginTop: THEME.spacing.lg,
		justifyContent: 'flex-start',
	},
	configurationContainer: {
		padding: `${THEME.spacing.lg} 0`,
	},
	configSection: {
		marginBottom: THEME.spacing.xl,
	},
	configSectionTitle: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.md,
	},
	configList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	configValue: {
		fontSize: THEME.typography.fontSizes.md,
		color: THEME.colors.text.main,
		padding: THEME.spacing.md,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.spacing.sm,
		backgroundColor: THEME.colors.background.light,
	},
	configSubValue: {
		display: 'block',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		marginTop: THEME.spacing.xs,
	},
});
